export enum FormActions {
  setFieldValue = "setFieldValue",
  setFormLoading = "setFormLoading",
  setFormErrors = "setFormErrors",
  resetFormState = "resetFormState",
  registerField = "registerField",
  setFieldErrors = "setFieldErrors",
  resetErrors = "resetErrors"
}
